import { useVersionCheck } from './useVersionCheck';

/**
 * Renders a "New version available / Refresh" banner when {@link useVersionCheck}
 * detects a newer deployed build id. Refresh performs a hard reload to pick up
 * the new bundle. Renders nothing when up to date.
 */
export function VersionBanner(): JSX.Element | null {
  const { updateAvailable } = useVersionCheck();

  if (!updateAvailable) {
    return null;
  }

  return (
    <div role="status" className="version-banner">
      <span>A new version of WarehouseLogix is available.</span>
      <button type="button" onClick={() => window.location.reload()}>
        Refresh
      </button>
    </div>
  );
}
